export default "__VITE_ASSET__d230364f__"